import { Theme, styled } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';

export const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  color: '#fff',
  WebkitFontSmoothing: 'auto',
  letterSpacing: 'normal',
}));
